import State from '../State';
import Utils from '../Utils';
import Notifications from '../components/Notifications';

class UploadService {
	static async beforeUpload(file) {
		if (file.type === 'image/png') {
			const validPng = await Utils.isPngAtuallyJpg(file);
			if (validPng === true) {
				Notifications.JPGSavedAsPNG(file.name);
				return Promise.reject(new Error('Invalid PNG file. JPG/JPEG file saved as PNG.'));
			}
		}
		if (Utils.isValidFile(file)) {
			State.addFile(file.uid, file.name, file.size);
		} else {
			Notifications.invalidFileFormat(file.name);
			return Promise.reject(new Error('Invalid file format.'));
		}
		// add file to table
		return Promise.resolve();
	}
	static onFileChange(info) {
		const { file } = info;
		if (file.status) {
			if (file.status === 'error') {
				State.removeFile(file.uid);
				Notifications.serverError(file.name);
			}
			if (file.status === 'done') {
				State.done(file.uid, file.response);
				// return, don't trigger update progress as FileProgress
				// component is unmounted.
				return;
			}
		}
		State.updateProgress(file.uid, file.percent);
	}
}

export default UploadService;



// WEBPACK FOOTER //
// ./src/services/UploadService.js